<template>
  <header data-v-e82090a2="" data-v-2ac6a5fc="" class="header-container" v-if="path != '/gamePage'">
    <div data-v-e82090a2="" class="header-new-center">
      <!-- 子页使用的头部 -->
      <div data-v-e82090a2="" class="button-left" v-if="bankShow"><span data-v-e82090a2="" class="back" @click="$router.back()"></span></div>
      <h1 data-v-e82090a2="" class="header-title" v-if="titleShow">
        <span data-v-e82090a2="">{{ title }}</span>
      </h1>
      <button data-v-e82090a2="" v-if="!bankShow" class="header-button left"><i data-v-e82090a2="" class="icon icon-menu2"></i></button>
      <h1 data-v-e82090a2="" v-if="!titleShow" class="header-title">
          <img  data-v-e82090a2=""   onerror="this.src = 'data:image/webp;base64,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'"  alt="LOGO"  class="logo" :src="$store.state.appInfo.site_logo"  />

       
      </h1>
      <div data-v-e82090a2="" class="header-button right" style="display: flex; align-items: center">
        <i data-v-e82090a2="" @click="$parent.goNav('/myNews')" class="icon-letter"></i>
        <div data-v-6ccba2c2="" data-v-e82090a2="" class="service-container">
          <div data-v-6ccba2c2="" class="service-button"><i data-v-6ccba2c2="" @click="changTabShow" class="icon-customer-service"></i></div>
          <ul data-v-6ccba2c2="" class="service-menu" v-if="tabShow">
            <li data-v-6ccba2c2="" class="arrow"></li>
            <li data-v-6ccba2c2="" class="service-menu-item" @click="$parent.openKefu()"><i data-v-6ccba2c2="" class="service-menu-item-icon service"></i>在线客服</li>
            <!-- <li data-v-6ccba2c2="" class="service-menu-item"><i data-v-6ccba2c2="" class="service-menu-item-icon phone"></i>免费电话</li>
            <li data-v-6ccba2c2="" class="service-menu-item phone-number"><a data-v-6ccba2c2="" href="tel:4001201721">4001201721</a></li> -->
          </ul>
          <div data-v-6ccba2c2="" class="service-button-mask" v-if="tabShow" @click="changTabShow"></div>
        </div>
      </div>
    </div>
  </header>
</template>
<script>
export default {
  name: 'Header',
  data() {
    return {
      tabShow: false,
      bankShow: false,
      titleShow: false,
      title: '',
      path:''
    };
  },
  created() {
    let that = this;
    this.changPath();
  },
  methods: {
    
    changTabShow(event) {
      event.stopPropagation();
      this.tabShow = !this.tabShow;
    },
    changPath() {
      let that = this;
      let path = this.$route.path;
      that.path = path;
      console.log(path);
      if (path == '/') {
        that.bankShow = false;
        that.titleShow = false;
        that.title = '';
      }
            if (path == '/kefu') {
        that.bankShow = false;
        that.titleShow = false;
        that.title = '连线客服';
      }
      
      if (path == '/about') {
        that.bankShow = true;
        that.titleShow = true;
        that.title = '关于我们';
      }
      if (path == '/faq') {
        that.bankShow = true;
        that.titleShow = true;
        that.title = '帮助中心';
      }
      if (path == '/userCenter') {
        that.bankShow = false;
        that.titleShow = true;
        that.title = '会员中心';
      }
      if (path == '/accountCenter') {
        that.bankShow = true;
        that.titleShow = true;
        that.title = '账户中心';
      }
      if (path == '/resetPasswordNew') {
        that.bankShow = true;
        that.titleShow = true;
        that.title = '修改密码';
      }
      if (path == '/modifyPhone') {
        that.bankShow = true;
        that.titleShow = true;
        that.title = '设置手机号';
      }
      if (path == '/modifyEmail') {
        that.bankShow = true;
        that.titleShow = true;
        that.title = '设置邮箱';
      }
      if (path == '/modifyPayPassword') {
        that.bankShow = true;
        that.titleShow = true;
        that.title = '设置资金密码';
      }
      if (path == '/bankCard') {
        that.bankShow = true;
        that.titleShow = true;
        that.title = '取款绑定管理';
      }
      if (path == '/addBankCard') {
        that.bankShow = true;
        that.titleShow = true;
        that.title = '添加银行卡';
      }
      if (path == '/addUsdtCard') {
        that.bankShow = true;
        that.titleShow = true;
        that.title = '添加USDT钱包';
      }
      if (path == '/myNews') {
        that.bankShow = true;
        that.titleShow = true;
        that.title = '我的消息';
      }
      if (path == '/myNewsInfo') {
        that.bankShow = true;
        that.titleShow = true;
        that.title = '消息详情';
      }
      if (path == '/assets') {
        that.bankShow = true;
        that.titleShow = true;
        that.title = '资产';
      }
      if (path == '/applyagent') {
        that.bankShow = true;
        that.titleShow = true;
        that.title = '申请代理';
      }
      if (path == '/applyagentList') {
        that.bankShow = true;
        that.titleShow = true;
        that.title = '活动申请记录';
      }
      if (path == '/activeList') {
        that.bankShow = false;
        that.titleShow = true;
        that.title = '优惠活动';
      }
      if (path == '/activeInfo') {
        that.bankShow = true;
        that.titleShow = true;
        that.title = '活动详情';
      }
      if (path == '/app') {
        that.bankShow = true;
        that.titleShow = true;
        that.title = 'APP / 游戏下载';
      }
      if (path == '/sponsor') {
        that.bankShow = true;
        that.titleShow = true;
        that.title = that.$store.state.appInfo.title + '风采';
      }
      if (path == '/vip') {
        that.bankShow = true;
        that.titleShow = true;
        that.title = 'VIP专区';
      }
      if (path == '/deposit') {
        that.bankShow = true;
        that.titleShow = true;
        that.title = '存款';
      }
      if (path == '/withdraw') {
        that.bankShow = true;
        that.titleShow = true;
        that.title = '取款';
      }
      if (path == '/games') {
        that.bankShow = true;
        that.titleShow = true;
        that.title = '电子游戏大厅';
      }
      if (path == '/gamePage') {
        that.bankShow = true;
        that.titleShow = true;
        that.title = '';
      }
      if (path == '/welfare') {
        that.bankShow = true;
        that.titleShow = true;
        that.title = '福利中心';
      }
            if (path == '/hongbao') {
        that.bankShow = true;
        that.titleShow = true;
        that.title = '抢红包';
      }

      
    },
  },
  mounted() {
    $('.mask .close').click(function () {
      $(this).parents('.mask').fadeOut(300);
    });
    //鼠标经过头像显示下拉菜单
    $('.user').hover(function () {
      $(this).find('.userImg .userNav').toggleClass('userNav--active');
    });
  },
  updated() {
    let that = this;
  },
  watch: {
    //监听路由地址的改变
    $route: {
      immediate: true,
      handler() {
        let that = this;
        
        that.changPath();
      },
    },
  },
};
</script>
<style lang="scss" scoped>
// @import '../../../static/css/chunk-b7675268.a1b3941c.css';
.service-menu .service-menu-item[data-v-6ccba2c2] {
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/libs/Header.vue